import * as types from './crudActionTypes.js';

export const setCrudTable = (table) => ({ type: types.SET_CRUDTABLE, table: table})
export const setAPITable = (api) => ({ type: types.SET_TABLEAPI, api: api})
export const setSchemeName = (schemeName) => ({ type: types.SET_SCHEMENAME, schemeName: schemeName})